import React from "react";
import * as XLSX from "xlsx";
import download_icon from "../../Icons/download_icon.png";

const super_admin = localStorage.getItem("super_admin");
const isSuperAdmin = super_admin === "true" || super_admin === true;
const ExcelExport = ({ expenseDetailResponse }) => {
  const exportToExcel = () => {
    // Check if leadResponse is not undefined or empty
    if (!expenseDetailResponse || expenseDetailResponse.length === 0) {
      return;
    }

    const headers = [
      "S.No.",
      "Lead ID",
      "Invoice Date",
      "Execution Date",
      "File Status",
      "Accounting Stage",
      "Invoice Number",
      "Quotation Number",
      "Shipment Ref. No.",
      "Billing Name",
      "Customer Name",
      "Lead Owner",
      "Operation Coordinator",
      "Field Coordinator",
      "Shipment Type",
      "Origin",
      "Destination",
      "Vendors",
      "No. of Pets",
      "Rate",
      "Chargeble Weight",
      "Cost Of Goods Sold",
      "Sales",
      "Payment Mode ",
      "Margin",
      "Invoice Status",
      "Bills Status",

      "CUSTOMER TYPE",
      "SUB CATEGORY",
      "LEAD TYPE",
      "LEAD REGION",
      "EMAIL",
      "MOBILE NO",
      "ALTERNATE NUMBER",
      "AIRLINE NAME",
      "TRANSPORT MODE",
      "DELIVERY TYPE NAME",
      "INVOICE AMOUNT WITH GST",
      "PROFITPERCENT",
      "AMOUNT IN AED",
      "ORDER STATUS NAME",
      "STAGE NAME",
      "SUB STAGE NAME",
      "PET NAME",
      "DIMENSION",
      "PET AGE",
      "PET TYPE",
      "PET BREED TYPE",
    ];

    const data = expenseDetailResponse.map((item, index) => ({
      "S.No.": index + 1,
      "Lead ID": item.Lead_ID,
      "Invoice Date": item.Execution_Date,
      "Execution Date": item.Execution_Date,
      "File Status": item.File_State,
      "Accounting Stage": item.shipment_stageName,
      "Invoice Number": item.Invoice_Number,
      "Quotation Number": item.Quotation_Number,
      "Shipment Ref. No.": item.Shipment_Ref_No,
      "Billing Name": item.Billing_Name,
      "Customer Name": item.Customer_Name,
      "Lead Owner": item.Lead_Owner,
      "Operation Coordinator": item.Operation_Coordinator,
      "Field Coordinator": item.Field_Coordinator,
      "Shipment Type": item.Shipment_Type,
      "Origin": item.Origin,
      "Destination": item.Destination,
      "Vendors": item.Vendors,
      "No. of Pets": item.Pieces,
      "Rate": item.Rate,
      "Chargeble Weight": item.Chargeble_Weight,
      "Cost Of Goods Sold": item.Cost_Of_Goods_Sold,
      "Sales": item.Sales,
      "Payment Mode ": item.Payment_Mode,
      "Margin": item.Margin,
      "Invoice Status": item.Invoice_Status,
      "Bills Status": item.Bills_Status,

      "CUSTOMER TYPE": item.customer_type,
      "SUB CATEGORY": item.sub_category,
      "LEAD TYPE": item.lead_type,
      "LEAD REGION": item.lead_region,
      "EMAIL": item.Email,
      "MOBILE NO": item.Mobile_No,
      "ALTERNATE NUMBER": item.alternate_number,
      "AIRLINE NAME": item.airline_name,
      "TRANSPORT MODE": item.transport_mode,
      "DELIVERY TYPE NAME": item.delivery_type_name,
      "INVOICE AMOUNT WITH GST": item.invoice_amount_with_gst,
      "PROFITPERCENT": item.ProfitPercent,
      "AMOUNT IN AED": item.Amount_In_AED,
      "ORDER STATUS NAME": item.order_status_name,
      "STAGE NAME": item.stage_name,
      "SUB STAGE NAME": item.sub_stage_name,
      "PET NAME": item.pet_Name,
      "DIMENSION": item.Dimension,
      "PET AGE": item.Pet_Age,
      "PET TYPE": item.PetType,
      "PET BREED TYPE": item.PetBreedType,


    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    // Generate today's date in YYYYMMDD format
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");

    // Save the Excel file with the new name
    const fileName = `ShipmentExecutionSheet_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, fileName, { type: "array" });
  };

  return isSuperAdmin ? (
    <button
      onClick={exportToExcel}
      style={{
        height: "47px",
        border: "1px solid #C0C6CC",
        borderRadius: "7.5px",
        color: "#6A6A6A",
      }}
    >
      <img src={download_icon} alt="download" /> Download Excel
    </button>
  ) : null;
};

export default ExcelExport;
